function getLetterbox(innerWidth, innerHeight) {
    innerWidth = innerWidth || window.innerWidth;
    innerHeight = innerHeight || window.innerHeight;
    let x, y, w, h;

    let paddingX = 0;
    let paddingY = 0;
    let ratio = 16 / 9;

    if (innerWidth / innerHeight < 1) { ratio = 9 / 16; }

    let viewerWidth = innerWidth - paddingX * 2;
    let viewerHeight = innerHeight - paddingY * 2;

    if (viewerWidth / viewerHeight >= ratio) {
        w = Math.ceil(viewerHeight * ratio);
        h = Math.ceil(viewerHeight);
    } else {
        w = Math.ceil(viewerWidth);
        h = Math.ceil(viewerWidth / ratio);
    }

    x = Math.floor(viewerWidth / 2 - w / 2 + paddingX);
    y = Math.floor(viewerHeight / 2 - h / 2 + paddingY);

    return { x, y, w, h };
}

export default getLetterbox;
export { getLetterbox };